"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _core = require("@material-ui/core");
var _FileType = _interopRequireDefault(require("./FileType"));
var _clsx = _interopRequireDefault(require("clsx"));
var _lab = require("@material-ui/lab");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _core.makeStyles)(function (theme) {
  return (0, _core.createStyles)({
    fileTypeWrap: {
      display: "flex",
      padding: theme.spacing(0.375, 0),
      alignItems: "center"
    },
    eventCode: _objectSpread({
      // mantis : 8550 (SH)
      // 일본어 선택 시 event code가 줄바뀜 되는 이슈로 인해 maxWidth 추가
      // maxWidth: 90,
      flex: 1,
      wordBreak: "break-word",
      display: "flex"
    }, theme.direction === "rtl" ? {
      marginRight: theme.spacing(0.5)
    } : {
      marginLeft: theme.spacing(0.5)
    })
  });
});

// TODO: 텍스트 vertical 가운데 정렬
// TODO: AI아이콘 옆 공간
var FileTypeContainer = function FileTypeContainer(props) {
  var _t;
  var fileType = props.fileType,
    eventCode = props.eventCode,
    className = props.className,
    style = props.style,
    loading = props.loading,
    isAI = props.isAI,
    t = props.t,
    eventNameClassName = props.eventNameClassName;
  var theme = (0, _core.useTheme)();
  var classes = useStyle(props);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.fileTypeWrap, className),
    style: style,
    dir: theme.direction
  }, loading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "rect",
    width: 50,
    height: 20
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "rect",
    width: 66,
    height: 20,
    className: classes.eventCode
  })), !loading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FileType.default, {
    isAI: isAI,
    fileType: fileType,
    t: t
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.eventCode, eventNameClassName)
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    htmlColor: _pittaModules.LightColors.primary["3"],
    category: "Default",
    variant: "Caption"
  }, eventCode !== undefined && ((_t = t === null || t === void 0 ? void 0 : t(_pittaModules.EventNames[eventCode])) !== null && _t !== void 0 ? _t : _pittaModules.EventNames[eventCode])))));
};
var _default = FileTypeContainer;
exports.default = _default;